import { usePageQuery } from 'src/hooks/use-page-query';
import type {
  PrismicArticleQueryVariables,
  PrismicArticleQuery,
} from 'src/types';
import query from '../query.graphql';

export function useEditorialContentPageQuery(
  variables: PrismicArticleQueryVariables
) {
  return usePageQuery<PrismicArticleQuery>({
    query,
    routeName: 'editorialContent',
    variables,
  });
}
